import React, {useState, useEffect, useRef, useContext} from 'react';
import Button from '../Button';
import useAPI from '../../hooks/useAPI';
import useFlash from '../../hooks/useFlash';
import FlashMessage from '../FlashMessage';
import RoundedButton from '../RoundedButton';
import AuthContext from "../../contexts/AuthContext";
import {areAllContractsCompleted} from "../../services/incompleteAgreementsService";

export default function PlaidButton ({ children, solid = true, accountId = null }) {
    const api = useAPI();
    const { messages, flash, remove } = useFlash();
    const {system, incompleteSystemsAgreements, showPlaidLinkBankAccountPopUp} = useContext(AuthContext);

    const [busy, setBusy] = useState(false);
    const [linkToken, setLinkToken] = useState(null);
    const [request, setRequest] = useState({})

    useEffect(()=>{
        if (showPlaidLinkBankAccountPopUp) {
            getLinkToken();
        }
        // eslint-disable-next-line
    }, []);

    const getLinkToken = () => {
        setBusy(true);
        setRequest(accountId ? {
            account_id: accountId
        } : {})
        api.updateShowPlaidLinkBankAccountPopUp(false)

        api.json('POST', '/payment-methods/plaid/create-link-token', request)
            .then(r => r.json())
            .then(r => {
                if (r.errors) {
                    flash(Array.isArray(r.errors) ? r.errors[0] : Object.values(r.errors)[0]);
                }

                setLinkToken(r?.data?.link_token);
            })
            .catch((e) => {
                alert(e);
                setBusy(false);
            });
    };

    const onSuccess = (publicToken) => {
        setBusy(true);

        api.json('POST', '/payment-methods/plaid/capture-token', {
            plaid_token: publicToken
        })
        .then(r => r.json())
        .then(r => {
            if (r.errors) {
                flash(Array.isArray(r.errors) ? r.errors[0] : Object.values(r.errors)[0]);
                return;
            }

            window.location = '/account/payment-settings';
        })
        .catch(e => alert(e))
        .then(() => setBusy(false));
    };

    const contractCompleted = incompleteSystemsAgreements.find(incompleteSystem => incompleteSystem.id === system.id)?.is_in_contract_status_for_enabling_plaid_button ?? true;
    const canSeeContract = incompleteSystemsAgreements.find(incompleteSystem => incompleteSystem.id === system.id)?.can_see_contract
    const allContractsCompleted = areAllContractsCompleted(incompleteSystemsAgreements, system.id);

    const attr = {
        onClick: getLinkToken,
        disabled: busy || (!contractCompleted && !allContractsCompleted),
        solid: solid
    }
    const isSolid = solid === true || solid === 'true';

    return (
        <>
            <FlashMessage messages={messages} onRemove={remove} />
            {
                !canSeeContract && !contractCompleted && <p style={{ color: 'red', fontSize: '13px', marginBottom: '5px'}}>System info not fully completed</p>
            }
            {
                isSolid
                ? <RoundedButton {...attr}>{children || 'Link Bank Account'}</RoundedButton>
                : <Button {...attr} >{children || 'Link Bank Account'}</Button>
            }
            {
                <PlaidHandler
                    token={linkToken}
                    onSuccess={onSuccess}
                    onExit={() => {
                        setBusy(false)
                        setLinkToken(null)
                    }}
                />
            }
        </>
    );
};

const PlaidHandler = ({ token, onSuccess, onExit }) => {
    const linkHandler = useRef(null);

    useEffect(() => {
        const checkLibrary = setInterval(() => {
            if (window.Plaid) {
                clearInterval(checkLibrary);

                if (linkHandler.current) {
                    linkHandler.current.destroy();
                }

                if (token) {
                    linkHandler.current = window.Plaid.create({
                        token,
                        onSuccess,
                        onExit,
                    });
                    linkHandler.current.open();
                }
            }
        }, 100);

        return () => clearInterval(checkLibrary);
    }, [token, onSuccess, onExit]);
};